module.exports = __webpack_public_path__ + "img/Bocata4Quesos_blur.d5bfb857.jpg";